import { uniqBy } from "lodash";
import { InfiniteData } from "react-query";
import { queryClient } from "../api/queryClient";
import { Page } from "../hooks/helper";
import { Resource } from "../types/Response";

type QueryDataType<T> = T[] | InfiniteData<Page<T>> | undefined;

/**
 * Search the cache for a collection of resources
 */
export const getCollection = <T extends Resource>(collection: string) => {
    const queries = queryClient.getQueriesData<QueryDataType<T>>(collection);
    const resources: T[] = [];

    for (const [, data] of queries) {
        if (!data) {
            continue;
        }

        if (Array.isArray(data)) {
            resources.push(...data);
        } else if ("pages" in data) {
            for (const page of data.pages) {
                resources.push(...page.data);
            }
        } else {
            resources.push(data);
        }
    }

    return uniqBy(resources, (resource) => resource.id);
};

/**
 * Search the cache for resource by ID
 */
export const getResource = <T extends Resource>(collection: string, id: ID): T | undefined => {
    return queryClient.getQueryData<T>([collection, id]);
};
